import ClientsTable from "views/Clients/components/DataTable";
import { useParams } from "react-router-dom";
import Dashboard from "./Dashboard";
import Documents from "./Documents";
import Payments from "./Payments";
import Settings from "./Settings";
import Catalog from "./Catalog";
import Setup from "./Setup";

export default function MainOutlet() {
  const { menu } = useParams();

  switch (menu) {
    case "setup":
      return <Setup />;
    case "dashboard":
      return <Dashboard />;
    case "catalog":
      return <Catalog />;
    case "payments":
      return <Payments />;
    case "settings":
      return <Settings />;
    case "documents":
      return <Documents />;
    default:
      return <ClientsTable />;
  }
}
